// libs
import React, { memo } from 'react';

//constants
import { ROLES } from 'shared/constants';

// hooks
import useKeyboardClick from 'shared/hooks/useKeyboardClick';

//helpers
import { generateTrackingUrlForMegaMenu } from 'shared/components/Header/helpers';

//types
import { FooterIconProps } from './types';

//styles
import { FooterIconContainer, FooterText, IconContainer } from './styles';

function FooterIcon({ text, children, url }: FooterIconProps) {
  const goToUrl = () => {
    window.location.href = typeof url === 'string' ? url : generateTrackingUrlForMegaMenu(url);
  };

  const keyboardProps = useKeyboardClick(goToUrl, { role: ROLES.LINK });

  return (
    <FooterIconContainer {...keyboardProps} aria-label={text}>
      <IconContainer aria-hidden>{children}</IconContainer>
      {!!text && <FooterText aria-hidden>{text}</FooterText>}
    </FooterIconContainer>
  );
}

export default memo(FooterIcon);
